import { UrlSegment } from "@angular/router";

export function passresetMatcher(url: UrlSegment[]) {
    return url[0].path === "ResetPassword" ? ({consumed: url}) : null; 
}